import React from "react";
import PropTypes from "prop-types";
import { useLocation, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import EditButton from "../../../backend/edit-button";
import ColorMask from "@default/js/participants/components/color-mask";
import SimpleDesignLinkButton from "@default/js/simple-design/simple-design-link-button";
import {ErrorBoundary} from "carbon-components-react";

const TeaserActMasked = ({ item, index, forceMask }) => {
  const adminApp = useSelector((reduxStore) => reduxStore.appStore.adminApp);

  const dispatch = useDispatch(),
    location = useLocation();

  return (
    <ErrorBoundary>
      <article
        className="node node-teaser teaser-act masked"
        data-index={index}
        tabIndex={-1}
      >
        <Link
          className="mask-wrapper flex-wrap infos-on-hover"
          to={item?.url?.path || item?.uri?.path}
          ariaLabel={item.title}
          forceSameTab={true}
        >
          <EditButton
            adminApp={adminApp}
            entityId={item.id}
            destinationRoute={location.pathname}
          />
          {item.fieldImage && (
            <>
              <div className="image">
                <img
                  src={item.fieldImage.fieldMediaImage?.style.url}
                  alt={item.fieldImage.fieldMediaImage?.alt}
                />
                <ColorMask
                  type={"teaser-participant"}
                  index={index}
                  useCssMask={true}
                />
              </div>
            </>
          )}
          <div className="hover-infos">
            <h3 className="name">{item.title}</h3>
            <SimpleDesignLinkButton label={"more_about_artist"}/>
          </div>
        </Link>
      </article>
    </ErrorBoundary>
  );
};

export const TeaserActMaskedPropTypes = PropTypes.shape({
  id: PropTypes.string,
  title: PropTypes.string,
  path: PropTypes.shape({
    alias: PropTypes.string,
  }),
  url: PropTypes.shape({
    path: PropTypes.string,
  }),
  fieldTags: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
    })
  ),
  fieldImage: PropTypes.shape({
    fieldMediaImage: PropTypes.shape({
      alt: PropTypes.string,
      title: PropTypes.string,
      style: PropTypes.shape({
        url: PropTypes.string,
      }),
    }),
  }),
});

TeaserActMasked.propTypes = {
  item: TeaserActMaskedPropTypes,
  pagerFullPage: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};

export default TeaserActMasked;
